// extracted by mini-css-extract-plugin
module.exports = {"transition":"BillSectionMobileBar_transition__rdlKt","bar":"BillSectionMobileBar_bar__3us2a","stickyBar":"BillSectionMobileBar_stickyBar__P7tWp"};